/**
 * Token de sessão do carrinho (rastreamento de abandono).
 *
 * É O MESMO token (`session_token_pedeja`) que o checkout envia ao registrar o pedido
 * (finalizarPedido.jsx → registerPedido → backend busca o carrinho por `session_token`).
 *
 * Pré-gerar este token no 1º item adicionado garante que o carrinho rastreado no
 * backend use exatamente o mesmo token que a finalização usará — assim, ao comprar,
 * o backend acha o carrinho e marca como finalizado/recuperado, sem gerar FALSO abandono.
 *
 * Antes, este token só era criado pelo backend DEPOIS do 1º pedido; aqui apenas
 * antecipamos a criação (mesmo formato/uso). Não altera o comportamento do pedido.
 */
export const getCartSessionToken = () => {
    try {
        let token = localStorage.getItem('session_token_pedeja');
        if (!token) {
            const uuid = (window.crypto && typeof window.crypto.randomUUID === 'function')
                ? window.crypto.randomUUID().replace(/-/g, '')
                : `${Date.now()}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
            token = uuid;
            localStorage.setItem('session_token_pedeja', token);
        }
        return token;
    } catch (e) {
        // localStorage indisponível (modo privado/itp) — tracking apenas degrada, não quebra
        return null;
    }
};

export default getCartSessionToken;
